'use client';

import React, { useEffect } from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import Loading from '@/components/loading/Loading';
import { initAuthSessionSync } from '@/utility/auth/initAuthSessionSync';
import { persistor, store } from './store';

const StoreProvider = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    initAuthSessionSync();
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
};

export default StoreProvider;
